import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { ChevronUp, ChevronDown } from 'lucide-react';

const FooterDisclosure = ({ label = 'Disclaimer', labelInSingleLine = false, linesToPreview = 2, text, isExpand, expandedNode, noLabel = false, noBorder = false }) => {
  const [isDisclaimerExpanded, setIsDisclaimerExpanded] = useState(false);

  return (
    <div className={noBorder ? '' : 'border-t border-gray-200 pt-6 mb-10'}>
      <button
        type="button"
        onClick={() => setIsDisclaimerExpanded(!isDisclaimerExpanded)}
        className={`flex items-start justify-between text-left group ${!isExpand ? 'cursor-default' : 'cursor-pointer'}`}
      >
        <p className={`text-xs text-gray-500 leading-relaxed pr-4 ${!isDisclaimerExpanded && isExpand ? `truncate-${linesToPreview}` : ''}`}>
          {!noLabel ? (
            <>
              <span className={`${labelInSingleLine ? 'block' : ''} font-semibold text-gray-600`}>{label}:</span>
              {' '}
            </>
          ) : null}
          {text}
        </p>
        {isExpand ? (
          <div className="flex-shrink-0 mt-3 text-gray-400 group-hover:text-gray-600 transition-colors">
            {isDisclaimerExpanded ? <ChevronUp className="w-4 h-4" /> : <ChevronDown className="w-4 h-4" />}
          </div>
        ) : null}
      </button>

      <div className={isDisclaimerExpanded ? 'block' : 'hidden'}>{expandedNode}</div>
    </div>
  );
};

FooterDisclosure.propTypes = {
  label: PropTypes.string,
  text: PropTypes.string.isRequired,
  isExpand: PropTypes.bool,
  expandedNode: PropTypes.node,
  linesToPreview: PropTypes.number,
  labelInSingleLine: PropTypes.bool,
  noLabel: PropTypes.bool,
  noBorder: PropTypes.bool,
}

FooterDisclosure.defaultProps = {
  label: 'Disclaimer',
  isExpand: false,
  expandedNode: null,
  linesToPreview: 2,
  labelInSingleLine: false,
  noLabel: false,
  noBorder: false,
};

export default FooterDisclosure;